import { render, staticRenderFns } from "./Attention.vue?vue&type=template&id=2a822fb2&scoped=true&"
import script from "./Attention.vue?vue&type=script&lang=js&"
export * from "./Attention.vue?vue&type=script&lang=js&"
import style0 from "./Attention.vue?vue&type=style&index=0&id=2a822fb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a822fb2",
  null
  
)

export default component.exports